const Nature = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer2"
      d="M32 19.011a1 1 0 0 1-1-1V2a1 1 0 1 1 2 0v16.01a1 1 0 0 1-1 1.001zM32 63a1 1 0 0 1-1-1V46.011a1 1 0 0 1 2 0V62a1 1 0 0 1-1 1zm30-30H46.014a1 1 0 0 1 0-2H62a1 1 0 0 1 0 2zm-43.986 0H2a1 1 0 0 1 0-2h16.014a1 1 0 0 1 0 2zm4.099-9.885a1 1 0 0 1-.707-.292L10.08 11.495a1 1 0 0 1 1.415-1.414l11.326 11.327a1 1 0 0 1-.707 1.707zm31.1 31.098a1 1 0 0 1-.707-.293L41.19 42.6a1 1 0 0 1 1.41-1.41l11.32 11.316a1 1 0 0 1-.707 1.707zM41.9 23.1a1 1 0 0 1-.707-1.707L52.506 10.08a1 1 0 0 1 1.414 1.42L42.606 22.808a1 1 0 0 1-.706.292zM10.785 54.213a1 1 0 0 1-.707-1.707L21.4 41.19a1 1 0 1 1 1.411 1.41L11.492 53.92a1 1 0 0 1-.707.293z"
      fill={color}
    ></path>
    <circle data-name="layer1" cx="32.014" cy="32.01" r="14" fill={color}></circle>
    <path data-name="opacity" d="M32 18.011a14 14 0 0 0 0 28z" fill="#000064" opacity=".1"></path>
  </svg>
);

export default Nature;
